import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate, Outlet } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { PreviewProvider } from "@/context/PreviewContext";
import { ProducerThemeProvider } from "@/components/producer";
import AuthCallback from "@/pages/AuthCallback";
import Landing from "@/pages/Landing";
import Partners from "@/pages/Partners";
import Signup from "@/pages/Signup";
import ProducerHome from "@/pages/ProducerHome";
import ProducerDashboard from "@/pages/ProducerDashboard";
import ProducerAccount from "@/pages/ProducerAccount";
import EventSetup from "@/pages/EventSetup";
import Flight from "@/pages/Flight";
import OperatorConsole from "@/pages/OperatorConsole";
import GuestAttribution from "@/pages/GuestAttribution";
import GuestSurvey from "@/pages/GuestSurvey";
import GuestNight from "@/pages/GuestNight";

function ProducerLayout() {
  return (
    <ProducerThemeProvider>
      <Outlet />
    </ProducerThemeProvider>
  );
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/partners" element={<Partners />} />
      <Route path="/signup" element={<Signup />} />
      <Route element={<ProducerLayout />}>
        <Route path="/producer" element={<ProducerHome />} />
        <Route path="/producer/account" element={<ProducerAccount />} />
        <Route path="/producer/events/:eventId" element={<ProducerDashboard />} />
        <Route path="/producer/events/:eventId/setup" element={<EventSetup />} />
      </Route>
      <Route path="/admin" element={<OperatorConsole />} />
      <Route path="/flight" element={<Flight />} />
      <Route path="/flight/join/:token" element={<Flight />} />
      <Route path="/operator" element={<Navigate to="/admin" replace />} />
      <Route path="/e/:slug" element={<GuestAttribution />} />
      <Route path="/survey/:slug" element={<GuestSurvey />} />
      <Route path="/n/:slug" element={<GuestNight />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <PreviewProvider>
            <AppRouter />
            <Toaster position="top-center" theme="dark" richColors />
          </PreviewProvider>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
